import React, { useContext, useState } from "react";
import { saveLayout, getLayoutList } from "../../api/s3";
import { StoreContext } from "../../store/Store";
import { actionTypes } from "../../store/storeTypes";
import { GlobalRefContext } from "../../store/GlobalRefs";

const buttonStyle = {
  padding: 10,
  borderRadius: 8,
  border: "1px solid black",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  cursor: "pointer",
};

const infoStyle = {
  padding: 10,
  borderRadius: 8,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: "#CECECE",
};

const popupstyle = {
  position: "absolute",
  top: 100,
  right: 20,
  border: "1px solid #000000",
  backgroundColor: "#ffffff",
  padding: 30,
  maxWidth: 200,
  zIndex: 10,
};

export const Controls = () => {
  const [store, dispatch] = useContext(StoreContext);
  const grefs = useContext(GlobalRefContext);
  const {
    auth,
    buttonStatus,
    flowLayout,
    flowConfig,
    mode,
    showStyle,
    showHandles,
    version,
    menuSelection,
    selectedCountry,
  } = store;

  const [showList, setShowList] = useState(false);
  const [layoutList, setLayoutList] = useState();

  const onStyle = () => {
    dispatch({ type: actionTypes.SET_SHOWSTYLE, payload: !showStyle });
    dispatch({
      type: actionTypes.SET_BUTTONSTATUS,
      payload: { ...buttonStatus, Style: !buttonStatus.Style },
    });
  };
  const onHandle = () => {
    dispatch({ type: actionTypes.SET_SHOWHANDLES, payload: !showHandles });
    dispatch({
      type: actionTypes.SET_BUTTONSTATUS,
      payload: { ...buttonStatus, Handles: !buttonStatus.Handles },
    });
  };
  const onReset = () => {
    dispatch({ type: actionTypes.SET_RESET, payload: true });
  };
  const onSave = () => {
    const version = prompt(
      "Please provide version description",
      flowLayout.source
    );
    dispatch({
      type: actionTypes.SET_BUTTONSTATUS,
      payload: { ...buttonStatus, Save: true },
    });
    const payload = {};
    payload["id"] = `${selectedCountry}_${menuSelection}`;
    payload["version"] = version;
    payload["source"] = version;

    payload["properties"] = grefs.positionRef.current.map((node) => {
      return {
        id: node.id,
        position: {
          x: Math.round(node.position.x),
          y: Math.round(node.position.y),
        },
        handles: grefs.handleRef.current[node.id],
      };
    });
    const asyncfunction = async () => {
      await saveLayout(auth, payload);
      dispatch({
        type: actionTypes.SET_VERSION,
        payload: version,
      });
      dispatch({
        type: actionTypes.SET_BUTTONSTATUS,
        payload: { ...buttonStatus, Save: false },
      });
    };
    asyncfunction();
  };
  const onCancel = () => {
    setShowList(false);
    dispatch({
      type: actionTypes.SET_BUTTONSTATUS,
      payload: { ...buttonStatus, Load: false },
    });
  };
  const setDefaultLayout = (val) => {
    const asyncfunction = async () => {
      setShowList(false);
      await saveLayout(auth, val);
      dispatch({ type: actionTypes.SET_FLOWLAYOUT, payload: val });
      dispatch({
        type: actionTypes.SET_BUTTONSTATUS,
        payload: { ...buttonStatus, Load: false },
      });
    };
    asyncfunction();
  };
  const onLoad = () => {
    dispatch({
      type: actionTypes.SET_BUTTONSTATUS,
      payload: { ...buttonStatus, Load: true },
    });
    const asyncfunction = async () => {
      const id = `${selectedCountry}_${menuSelection}`;
      const ret = await getLayoutList(auth, id);
      setLayoutList(ret.filter((item) => item.version !== "default"));
      setShowList(true);
    };
    asyncfunction();
  };
  return mode === "layout" ? (
    <div
      style={{
        // position: "absolute",
        // top: 0,
        // left: "50%",
        height: 40,
        backgroundColor: flowConfig.layoutBackgroundColor,
        display: "flex",
        gap: 30,
        // transform: "translate(-50%, 0%)",
        zIndex: 10,
      }}
    >
      {showList && (
        <div style={popupstyle}>
          {layoutList.map((item, i) => {
            return (
              <div key={i} style={{ display: "flex" }}>
                <input
                  type={"checkbox"}
                  onChange={() => setDefaultLayout(item)}
                ></input>
                <div>{item.version}</div>
              </div>
            );
          })}
          <div
            onClick={() => onCancel()}
            style={{ ...buttonStyle, marginTop: 20 }}
          >
            Cancel
          </div>
        </div>
      )}

      <div
        style={{
          ...buttonStyle,
          backgroundColor: buttonStatus.Save ? "grey" : "#ffffff",
        }}
        onClick={() => onSave()}
      >
        Save
      </div>
      <div
        style={{
          ...buttonStyle,
          backgroundColor: buttonStatus.Load ? "grey" : "#ffffff",
        }}
        onClick={() => onLoad()}
      >
        Load
      </div>
      <div style={buttonStyle} onClick={() => onReset()}>
        Reset
      </div>
      <div
        style={{
          ...buttonStyle,
          backgroundColor: buttonStatus.Handles ? "grey" : "#ffffff",
        }}
        onClick={() => onHandle()}
      >
        Handles
      </div>
      <div
        style={{
          ...buttonStyle,
          backgroundColor: buttonStatus.Style ? "grey" : "#ffffff",
        }}
        onClick={() => onStyle()}
      >
        Style
      </div>
      <div style={infoStyle}>
        <div>
          <div>Layout</div>
          <div>{version}</div>
        </div>
      </div>
      <div style={infoStyle}>
        <div>
          <div>Style</div>
          <div>{flowConfig.source}</div>
        </div>
      </div>
      <div style={infoStyle}>
        <div>
          <div>Country</div>
          <div>{selectedCountry}</div>
        </div>
      </div>
    </div>
  ) : null;
};
